import home from './home.json'
import homeOrganic from './homeOrganic.json'
import homeEmbed from './homeEmbed.json'
import producers from './producers.json'
import about from './about.json'
import affiliates from './affiliates.json'
import solutions from './solutions.json'
import hotmartApp from './hotmartApp.json'
import tour from './tour.json'
import payments from './payments.json'
import legal from './legal.json'
import membersArea from './membersArea.json'
import newSolutions from './newSolutions.json'
import newMembersArea from './newMembersArea.json'

export default {
  home,
  homeOrganic,
  homeEmbed,
  producers,
  about,
  affiliates,
  solutions,
  hotmartApp,
  tour,
  payments,
  legal,
  membersArea,
  newSolutions,
  newMembersArea,
}
